<template>
  <Layout>
    <div class="row">
      <PageHeader class="col-11" title="Device Management" />
    </div>
    <!-- Search and Create new package -->
    <div class="row mb-2">
      <div class="col-sm-4">
        <div class="search-box me-2 mb-2 d-inline-block">
          <div class="position-relative">
            <b-form-input
              v-model="filter"
              type="search"
              class="form-control"
              placeholder="Search Device"
            ></b-form-input>
            <i class="bx bx-search-alt search-icon"></i>
          </div>
        </div>
      </div>
      <div class="col-sm-8">
        <div class="text-sm-end">
          <button
            type="button"
            @click="showCreatePackageModal"
            class="btn btn-info btn-rounded mb-2 me-2"
          >
            <i class="mdi mdi-plus me-1"></i>
            {{ $t("menuitems.administration.list.device.list.add") }}
          </button>
          <button
            type="button"
            @click="showImportModal"
            class="btn btn-info btn-rounded mb-2 me-2"
          >
            <i class="mdi mdi-download me-1"></i
            >{{ $t("menuitems.administration.list.device.list.import") }}
          </button>
        </div>
      </div>
    </div>

    <!-- Devices Table -->
    <div class="table-responsive mb-0">
      <b-table
        class="datatables"
        :items="allDevices"
        :fields="fields"
        responsive="sm"
        :per-page="0"
        :current-page="currentPage"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :filter="filter"
        :filter-included-fields="filterOn"
        @filtered="onFiltered"
      >
        <template #cell(role_name)="row">
          <span>{{ String(row.item.role_name).toUpperCase() }}</span>
        </template>

        <template #cell(updated_at)="row">
          <span
            >{{ new Date(row.item.updated_at).toLocaleDateString() }}
            {{ new Date(row.item.updated_at).toLocaleTimeString() }}</span
          >
        </template>

        <template #cell(is_active)="row">
          <span :class="`badge ${getStatusClass(row.item.is_active)}`">{{
            row.item.is_active ? "Active" : "Disabled"
          }}</span>
        </template>

        <template #cell(actions)="row">
          <b-button
            size="sm"
            variant="primary"
            class="m-1"
            @click="openModifyDeviceModal(row.item)"
          >
            Modify
          </b-button>
          <b-button
            size="sm"
            variant="danger"
            class="m-1"
            @click="deleteDevice(row.item.id)"
          >
            Delete
          </b-button>
        </template>
      </b-table>
    </div>
    <div class="row">
      <div class="col">
        <div class="dataTables_paginate paging_simple_numbers float-end mb-3">
          <ul class="pagination pagination-rounded mb-0">
            <!-- pagination -->
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
            ></b-pagination>
          </ul>
        </div>
      </div>
    </div>

    <!-- Create new device modal -->
    <b-modal
      id="create-new-device-modal"
      title-class="font-18"
      no-close-on-backdrop
      hide-footer
      centered
    >
      <template #modal-header>
        <div><h5>Add New Device</h5></div>
        <div>
          <button
            class="btn btn-sm btn-outline-danger"
            @click="$bvModal.hide('create-new-device-modal')"
          >
            Cancel
          </button>
        </div>
      </template>
      <form @submit.prevent="createNewDevice">
        <div class="row">
          <div class="col-12">
            <div class="mb-3">
              <label>Device Name</label>
              <input
                placeholder="Enter Device Name"
                v-model="createNewDeviceObj.name"
                type="text"
                class="form-control inp-bg"
                required
              />
            </div>
          </div>
          <div class="col-6">
            <div class="mb-3">
              <label>Device Type</label>
              <b-form-select
                placeholder="Select Device Type"
                v-model="createNewDeviceObj.type"
                :options="types"
                class="form-control inp-bg"
                required
              >
              </b-form-select>
            </div>
          </div>
          <div class="col-6">
            <div class="mb-3">
              <label>Device IP</label>
              <input
                placeholder="Enter Device IP"
                v-model="createNewDeviceObj.ip"
                type="text"
                class="form-control inp-bg"
                required
              />
            </div>
          </div>
          <div class="col-6">
            <div class="mb-3">
              <label>Network Port</label>
              <input
                placeholder="Enter Network Port"
                v-model="createNewDeviceObj.port"
                type="number"
                max="65000"
                class="form-control inp-bg"
                required
              />
            </div>
          </div>
          <div class="col-6">
            <div class="mb-3">
              <label>Chainage No.</label>
              <input
                placeholder="Enter Chainage Number"
                v-model="createNewDeviceObj.chainage"
                type="text"
                class="form-control inp-bg"
                required
              />
            </div>
          </div>
          <div class="col-6">
            <div class="mb-3">
              <label>Latitude</label>
              <input
                placeholder="Enter Device Latitude"
                v-model="createNewDeviceObj.lat"
                type="text"
                class="form-control inp-bg"
                required
              />
            </div>
          </div>
          <div class="col-6">
            <div class="mb-3">
              <label>Longitude</label>
              <input
                placeholder="Enter Device Longitude"
                v-model="createNewDeviceObj.long"
                type="text"
                class="form-control inp-bg"
                required
              />
            </div>
          </div>
        </div>

        <hr />

        <!-- BUTTON -->
        <div class="row">
          <div class="col-12">
            <div class="mt-2 text-center">
              <button type="submit" class="btn btn-primary me-1 w-50">
                Add Device <i class="bx bx-rocket ml-2"></i>
              </button>
            </div>
          </div>
        </div>
      </form>
    </b-modal>

    <!-- edit new device modal -->
    <b-modal
      id="edit-device-modal"
      title-class="font-18"
      no-close-on-backdrop
      hide-footer
      centered
    >
      <template #modal-header>
        <div><h5>Modify Device</h5></div>
        <div>
          <button
            class="btn btn-sm btn-outline-danger"
            @click="$bvModal.hide('edit-device-modal')"
          >
            Cancel
          </button>
        </div>
      </template>
      <form @submit.prevent="updateDevice">
        <div class="row">
          <div class="col-12">
            <div class="mb-3">
              <label>Device Name</label>
              <input
                placeholder="Enter Device Name"
                v-model="updateDeviceObj.device_name"
                type="text"
                class="form-control inp-bg"
                required
              />
            </div>
          </div>
          <div class="col-6">
            <div class="mb-3">
              <label>Device Type</label>
              <v-select
                v-model="deviceType"
                :options="types"
                label="text"
                :reduce="(vc) => vc.text"
              ></v-select>
            </div>
          </div>
          <div class="col-6">
            <div class="mb-3">
              <label>Device IP</label>
              <input
                placeholder="Enter Device IP"
                v-model="updateDeviceObj.device_ip"
                type="text"
                class="form-control inp-bg"
                required
              />
            </div>
          </div>
          <div class="col-6">
            <div class="mb-3">
              <label>Network Port</label>
              <input
                placeholder="Enter Network Port"
                v-model="updateDeviceObj.device_port"
                type="number"
                max="65000"
                class="form-control inp-bg"
                required
              />
            </div>
          </div>
          <div class="col-6">
            <div class="mb-3">
              <label>Chainage No.</label>
              <input
                placeholder="Enter Chainage Number"
                v-model="updateDeviceObj.chainage"
                type="text"
                class="form-control inp-bg"
              />
            </div>
          </div>
          <div class="col-6">
            <div class="mb-3">
              <label>Latitude</label>
              <input
                placeholder="Enter Device Latitude"
                v-model="updateDeviceObj.lat"
                type="text"
                class="form-control inp-bg"
                required
              />
            </div>
          </div>
          <div class="col-6">
            <div class="mb-3">
              <label>Longitude</label>
              <input
                placeholder="Enter Device Longitude"
                v-model="updateDeviceObj.long"
                type="text"
                class="form-control inp-bg"
                required
              />
            </div>
          </div>
        </div>

        <hr />

        <!-- BUTTON -->
        <div class="row">
          <div class="col-12">
            <div class="mt-2 text-center">
              <button type="submit" class="btn btn-primary me-1 w-50">
                Modify Device <i class="bx bx-rocket ml-2"></i>
              </button>
            </div>
          </div>
        </div>
      </form>
    </b-modal>

    <!-- Import from NMS modal -->
    <b-modal
      id="import-device-modal"
      title-class="font-18"
      no-close-on-backdrop
      hide-footer
      centered
    >
      <template #modal-header>
        <div>
          <h5 v-if="zabbixGroups.length === 0">Select NMS Account</h5>
          <h5 v-else>Select NMS Group</h5>
        </div>
        <div>
          <button
            class="btn btn-sm btn-outline-danger"
            @click="closeImportModal"
          >
            Close
          </button>
        </div>
      </template>

      <!-- Show all NMS Accounts -->
      <div v-if="zabbixGroups.length === 0">
        <div
          style="max-height: 550px; overflow: auto"
          v-if="nmsAccounts.length > 0"
        >
          <b-list-group v-for="(nms, index) in nmsAccounts" :key="index">
            <b-list-group-item
              class="d-flex justify-content-between align-items-center"
            >
              {{ nms.name }}
              <b-button
                :id="`import-nms-btn-${index}`"
                variant="primary"
                size="sm"
                @click="connectZabbixInstance(nms.id)"
              >
                Select NMS</b-button
              >
            </b-list-group-item>
          </b-list-group>
        </div>
        <div class="text-center p-3" v-else>
          <p>Please add NMS Account first</p>
          <router-link to="/administration/nms-management">
            <button class="btn btn-primary">
              Go to NMS Management <i class="fa fa-arrow-right ms-2"></i>
            </button>
          </router-link>
        </div>
      </div>

      <!-- Import Devices from Group -->
      <div v-else>
        <div class="search-box mb-3 d-inline-block">
          <div class="position-relative">
            <b-form-input
              type="search"
              class="form-control"
              placeholder="Search Group"
              v-model="filterSearch"
              @keyup="filterGroups"
            ></b-form-input>
            <i class="bx bx-search-alt search-icon"></i>
          </div>
        </div>
        <div style="max-height: 550px; overflow: auto">
          <b-list-group
            v-for="(group, index) in filteredZabbixGroups"
            :key="index"
          >
            <b-list-group-item
              class="d-flex justify-content-between align-items-center"
            >
              {{ group.name }}
              <small class="text-success" v-if="group.isImported"
                >(Already Imported)</small
              >
              <b-button
                :id="`import-btn-${index}`"
                variant="primary"
                size="sm"
                @click="importZabbixDevices(group, `import-btn-${index}`)"
                ><i class="bx bxs-download"></i> Import Devices</b-button
              >
            </b-list-group-item>
          </b-list-group>
        </div>
      </div>
    </b-modal>
  </Layout>
</template>
<script>
import Layout from "@/layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import adminMixin from "@/mixins/administration";
import gisMixin from "@/mixins/gis";
import Swal from "sweetalert2";

export default {
  page: {
    title: "Device Management",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  data() {
    return {
      createNewDeviceObj: {},
      updateDeviceObj: {},
      selectedNmsId: null,
      deviceType: null,
      zabbixObj: {},
      filterSearch: "",
      filteredZabbixGroups: [],
      nmsAccounts: [],
      zabbixGroups: [],
      types: [],
      allDevices: [],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      sortBy: "id",
      sortDesc: false,
      filterOn: [],
      filter: null,
      fields: [
        {
          key: "id",
          label: "ID",
          sortable: true,
        },
        {
          key: "device_name",
          label: "Device Name",
          sortable: false,
        },
        {
          key: "device_type",
          label: "Device Type",
          sortable: false,
        },
        {
          key: "device_ip",
          label: "Device IP",
          sortable: false,
        },
        {
          key: "device_port",
          label: "Port",
          sortable: false,
        },
        {
          key: "updated_at",
          label: "Last Updated",
          sortable: false,
        },
        {
          key: "actions",
          sortable: false,
          label: "Action",
        },
      ],
    };
  },
  components: {
    Layout,
    PageHeader,
  },
  mixins: [adminMixin, gisMixin],
  async mounted() {
    const types = await this.GetDeviceTypes();
    this.allDevices = await this.GetAllDevices();
    this.$store.dispatch("gis/setDevices", this.allDevices);

    this.types = [];
    for (let deviceType of types) {
      this.types.push({
        value: deviceType.id,
        text: deviceType.type_name,
      });
    }

    this.zabbixGroups = [];
    this.filteredZabbixGroups = [];
  },
  methods: {
    openModifyDeviceModal(device) {
      this.updateDeviceObj = device;
      this.deviceType = device.device_type;
      this.$bvModal.show("edit-device-modal");
    },

    async updateDevice() {
      try {
        let deviceData = null;
        if (this.deviceType) {
          const data = this.types.find(
            (devices) => devices.text === this.deviceType
          );
          deviceData = data;
        }
        const body = {
          id: this.updateDeviceObj.id,
          device_name: this.updateDeviceObj.device_name,
          device_type_id: deviceData.value,
          device_type: deviceData.text,
          device_ip: this.updateDeviceObj.device_ip,
          device_port: this.updateDeviceObj.device_port,
          chainage: this.updateDeviceObj.chainage,
          lat: this.updateDeviceObj.lat,
          long: this.updateDeviceObj.long,
        };
        await this.UpdateDevice(body);
        this.allDevices = await this.GetAllDevices();
        Swal.fire(
          "Device Updated",
          "Device updated successfully",
          "success"
        ).then(() => {
          this.$bvModal.hide("edit-device-modal");
        });
      } catch (e) {
        Swal.fire("Failed!", "Can not update device", "error").then(() => {
          this.$bvModal.hide("edit-device-modal");
        });
      }
    },

    async deleteDevice(id) {
      try {
        const body = {
          id: id,
        };
        await this.DeleteDevice(body);
        this.allDevices = await this.GetAllDevices();
        Swal.fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes, delete it!",
        }).then(async (result) => {
          if (result.isConfirmed) {
            Swal.fire(
              "Converted!",
              "This device is deleted successfully.",
              "success"
            );
          }
        });
      } catch (e) {
        Swal.fire("Failed!", "Can not update device", "error");
      }
    },

    filterGroups() {
      this.filteredZabbixGroups = this.zabbixGroups.filter((e) =>
        String(e.name).toLowerCase().includes(this.filterSearch)
      );
    },
    showCreatePackageModal() {
      this.zabbixGroups = [];
      this.filteredZabbixGroups = [];
      this.$bvModal.show("create-new-device-modal");
    },
    
    async closeImportModal() {
      this.zabbixGroups = [];
      this.filteredZabbixGroups = [];
      this.$bvModal.hide("import-device-modal");

      const types = await this.GetDeviceTypes();
      this.allDevices = await this.GetAllDevices();
      this.$store.dispatch("gis/setDevices", this.allDevices);

      this.types = [];
      for (let deviceType of types) {
        this.types.push({
          value: deviceType.id,
          text: deviceType.type_name,
        });
      }

      this.zabbixGroups = [];
      this.filteredZabbixGroups = [];
    },

    async createNewDevice() {
      try {
        this.$store.dispatch("layout/changeLoaderValue", true);
        await this.AddNewDevice(this.createNewDeviceObj);

        this.createNewDeviceObj = {};
        this.$store.dispatch("layout/changeLoaderValue", false);
        Swal.fire("Device Added", "Device saved successfully", "success").then(
          () => {
            this.$bvModal.hide("create-new-device-modal");
          }
        );
        this.allDevices = await this.GetAllDevices();
        this.$store.dispatch("gis/setDevices", this.allDevices);
      } catch (e) {
        Swal.fire("Failed!", e.response.data.message, "warning");
      }
    },

    async connectZabbixInstance(nmsId) {
      try {
        this.$store.dispatch("layout/changeLoaderValue", true);
        const res = await this.ConnectZabbix({
          id: nmsId,
        });

        this.selectedNmsId = nmsId;
        this.zabbixGroups = res;
        this.filteredZabbixGroups = res;
        this.$store.dispatch("layout/changeLoaderValue", false);

        if (this.zabbixGroups.length === 0) {
          Swal.fire(
            "No Groups Found",
            "We could not find configured groups in NMS. Please configure the NMS first or check username and password.",
            "error"
          );
        }

        this.zabbixObj = {};
      } catch (e) {
        Swal.fire("Failed!", e.response.data.message, "error");
      }
    },
    async importZabbixDevices(groupObj, btnId) {
      try {
        const btn = document.getElementById(btnId);
        if (btn) btn.disabled = true;
        this.$store.dispatch("layout/changeLoaderValue", true);
        const res = await this.ImportGroupAndDevices({
          ...groupObj,
          nmsId: this.selectedNmsId,
        });
        this.zabbixObj = {};

        if (btn)
          btn.innerHTML = `<i class="mdi mdi-check"></i> ${res.devices} Devices Imported`;
        if (btn) btn.variant = `success`;

        this.$store.dispatch("layout/changeLoaderValue", false);
        Swal.fire(`${res.devices} Devices Imported`, "", "success");
      } catch (e) {
        Swal.fire("Failed!", e.response.data.message, "error");
      }
    },

    async showImportModal() {
      try {
        this.$store.dispatch("layout/changeLoaderValue", true);
        this.nmsAccounts = await this.GetNMSAccounts();
        this.$store.dispatch("layout/changeLoaderValue", false);

        this.$bvModal.show("import-device-modal");
      } catch (e) {
        Swal.fire("Failed!", e.response.data.message, "error");
      }
    },

    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
  },
};
</script>
